
import { createTheme } from '@mui/material/styles';

export const darkBg = 'rgb(25, 17, 19)';
export const darkTxt = 'rgb(239, 223, 225)';
export const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: 'rgb(255, 176, 200)',
        contrastText: 'rgb(84, 29, 50)',
      },
      secondary: {
        main: 'rgb(226, 189, 198)',
        contrastText: 'rgb(66, 41, 49)',
      },
      tertiary: {
        main: 'rgb(239, 189, 148)',
        contrastText: 'rgb(72, 41, 12)',
      },
      error: {
        main: 'rgb(255, 180, 171)',
        contrastText: 'rgb(105, 0, 5)',
      },
      background: {
        default: 'rgb(25, 17, 19)',
        paper: 'rgb(25, 17, 19)',
      },
      surface: {
        main: 'rgb(25, 17, 19)',
        variant: 'rgb(81, 67, 71)',
        dim: 'rgb(25, 17, 19)',
        bright: 'rgb(65, 55, 57)',
        container: 'rgb(38, 29, 32)',
        containerLow: 'rgb(34, 25, 28)',
        containerHigh: 'rgb(49, 40, 42)',
      },
      text: {
        primary: 'rgb(239, 223, 225)',
        secondary: 'rgb(213, 194, 198)',
        disabled: 'rgb(158, 140, 144)',
        hint: 'rgb(213, 194, 198)',
      },
    },
    typography: {
      fontFamily: 'Comfortaa, sans-serif',
    },
    overrides: {
      MuiButton: {
        // Add button overrides if needed
      },
      // Add more overrides as needed
    },
  });
  
export const lightBg = 'rgb(255, 248, 248)';
export const lightTxt = 'rgb(34, 25, 28)';
  export const lightTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: 'rgb(140, 74, 96)',
        contrastText: 'rgb(255, 255, 255)',
      },
      secondary: {
        main: 'rgb(116, 86, 95)',
        contrastText: 'rgb(255, 255, 255)',
      },
      tertiary: {
        main: 'rgb(124, 86, 53)',
        contrastText: 'rgb(255, 255, 255)',
      },
      error: {
        main: 'rgb(186, 26, 26)',
        contrastText: 'rgb(255, 255, 255)',
      },
      background: {
        default: 'rgb(255, 248, 248)',
        paper: 'rgb(255, 248, 248)',
      },
      surface: {
        main: 'rgb(255, 248, 248)',
        variant: 'rgb(242, 221, 226)',
        dim: 'rgb(230, 214, 217)',
        bright: 'rgb(255, 248, 248)',
        container: 'rgb(250, 234, 237)',
        containerLow: 'rgb(255, 240, 242)',
        containerHigh: 'rgb(245, 228, 231)',
      },
      text: {
        primary: 'rgb(34, 25, 28)',
        secondary: 'rgb(81, 67, 71)',
        disabled: 'rgb(131, 115, 119)',
        hint: 'rgb(213, 194, 198)',
      },
    },
    typography: {
      fontFamily: 'Comfortaa, sans-serif',
    },
    overrides: {
      MuiButton: {
        // Add button overrides if needed
      },
      // Add more overrides as needed
    },
  });